/**
 * Client-side fetch utility that bypasses Rill's middleware chain.
 * Use this for interactions that don't need a URL change (modals, tabs, inline edits).
 *
 * @param {string} path - The URL path (e.g. "/actions/meal-planner/meal-plan-review")
 * @param {Object} [options]
 * @param {Object} [options.query] - Query parameters as key-value pairs
 * @param {Object} [options.body] - JSON body (automatically stringified)
 * @param {string} [options.method="GET"] - HTTP method
 * @returns {Promise<any>} Parsed JSON response
 */
export async function clientFetch(path, { query, body, method = "GET" } = {}) {
  const url = new URL(path, globalThis.location.origin);
  if (query) {
    Object.entries(query).forEach(([k, v]) => {
      url.searchParams.set(k, v);
    });
  }

  const res = await fetch(url.toString(), {
    method,
    credentials: "same-origin",
    headers: body ? { "Content-Type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const error = new Error(`clientFetch failed: ${res.status}`);
    error.status = res.status;
    throw error;
  }

  return res.json();
}
